import React, { useEffect, useState } from 'react';
import numberToWords from 'number-to-words'
import { PDFViewer, PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { charAtIndex } from 'pdf-lib';


const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        // padding: 10,
        display: "flex",
        paddingLeft: 20,
        paddingRight: 20,
        fontStyle: 'italic'

    },
    header: {
        padding: 10,
        flexDirection: 'column',
        marginBottom: 10,
    },
    headerText: {
        fontSize: 14,
    },
    content: {
        flexGrow: 1,
        // marginBottom: 90
    },

    newContent: {
        flexGrow: 1,
        marginTop: 30,
        marginBottom: 90

    },

    customer_container: {
        flexDirection: "row",
    },

    customer: {
        fontSize: 10,
        marginLeft: 10,
        // padding: 10,
        borderRadius: 5,
        marginRight: 210
    },
    customerInfoRow: {
        flexDirection: 'column',
        marginBottom: 8,
    },
    label: {
        fontWeight: '700',
        marginBottom: 5,
    },
    value: {
        // flex: 1,
    },

    table: {
        width: '97.7%',
        border: '1px solid #000',
        borderBottom: 0,
        // borderTopLeftRadius: 10,
        // borderTopRightRadius: 10
    },
    headerCell: {
        // borderRight: '1px solid #000',
        // backgroundColor: '#f2f2f2',
        paddingTop: 5,
        paddingBottom: 5,
        fontSize: 9,
        // alignSelf: "center"
    },
    row: {
        flexDirection: 'row',
        borderBottom: '1px solid #000',
        // padding: 0.2
        // backgroundColor: '#f2f2f2',
        // left: -10
        // paddingVertical: 5,
        // paddingHorizontal: 5,    
        // height: 30
    },
    cell: {
        // width: "20%",
        // textAlign: 'center',
        fontSize: 8,
        // fontFamily: 'FamilyName',
        // paddingVertical: 5,
        // paddingHorizontal: 5,
    },
    rightAlign: {
        // textAlign: 'center',
        justifyContent: "center",
        textAlign: "right"
    },
    footer: {
        // marginTop: 70,
        padding: 10,
        fontSize: 10,
        // textAlign: 'center',
        // marginTop: 10,
        marginBottom: 20

    },
});


const CreatePdf_Formate5 = () => {

    const [items, setItems] = useState([])
    const printData = JSON.parse(sessionStorage.getItem('printData'));

    const initialItems = [
        { id: 1, item_name: 'Laptop', description: 'Dell XPS 13', locations: [] },
        { id: 2, item_name: 'Smartphone', description: 'iPhone 12', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 1, item_name: 'Laptop', description: 'Dell XPS 13', locations: [] },
        { id: 2, item_name: 'Smartphone', description: 'iPhone 12', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },
        { id: 3, item_name: 'Tablet', description: 'iPad Pro', locations: [] },

    ];


    useEffect(() => {
        // Function to add location data to items
        const addLocationsToItems = (items, locations) => {
            const itemMap = items.reduce((acc, item) => {
                acc[item.item_code] = { ...item, locations: [] };
                return acc;
            }, {});

            locations.forEach(location => {
                if (itemMap[location.item_code]) {
                    itemMap[location.item_code].locations.push({
                        location: location.item_stock_location,
                        serialNumber: location.item_batch_no,
                    });
                }
            });

            return Object.values(itemMap);
        };

        // Merge location data into items
        const updatedItems = addLocationsToItems(printData?.ItemTable, printData?.stockDetailTable);
        setItems(updatedItems);

        // console.log(updatedItems, "update item s dataa @@@")
    }, []);


    console.log(printData, "print Daya")


    // printData.ItemTable
    // const items =  printData.ItemTable
    // [
    // { item_name: 'Our choice of books reflects our personality and our intellect', item_rate_one_pc: 123456.00, item_qty: 2, total_amount_with_gst_one_pc: 9999999.99 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // { item_name: 'Item 2', item_amount: 5.49, item_qty: 3, item_amount: 16.47 },
    // ];

    const pages = Math.ceil((items.length - 30) / 43) + 1; // Adjusted to account for the first page's 30 items

    function capitalizeFirstLetter(string) {
        return string.charAt(0)?.toUpperCase() + string?.slice(1);
    }

    // const totalQty = aggrementTable.reduce((acc, item) =>
    //   acc + parseFloat(item.issue_qty || 0),
    //   0
    // );

    // number convert to word 
    let number = printData?.challanMasterData?.final_amount?.toFixed(2) ? printData?.challanMasterData?.final_amount?.toFixed(2) : 0
    const result = capitalizeFirstLetter(numberToWords?.toWords(number));

    const renderPages = () => {
        const pageViews = [];

        for (let i = 0; i < pages; i++) {
            const isFirstPage = i === 0;
            const isLastPage = i === pages - 1;

            const startIndex = isFirstPage ? 0 : 30 + (i - 1) * 43;
            const endIndex = isFirstPage ? 30 : startIndex + 43;
            const itemsForPage = items.slice(startIndex, endIndex);

            console.log(itemsForPage,"item page conde")

            pageViews.push(
                <View key={i} style={isFirstPage ? styles.content : styles.newContent}>
                    {/* <View style={{ borderTopWidth: 1, borderRightColor: 'black', width: 491, left: -10 }}></View> */}
                    <View style={[styles.table, { minHeight: 300 }]}>
                        {/* Table Header */}
                        <View style={[styles.row, { borderTopLeftRadius: 7, borderTopRightRadius: 7 }]}>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: "5%", borderRight: " 1px solid black" }]}>S.No.</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '25%', borderRight: " 1px solid black" }]}>Description of Goods</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '10%', borderRight: " 1px solid black" }]}>HSN Code</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '10%', borderRight: " 1px solid black" }]}>Quantity</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '10%', borderRight: " 1px solid black" }]}>Unit</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '11%', borderRight: " 1px solid black" }]}>Rate</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '13%', borderRight: " 1px solid black" }]}>Taxable</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '8%', borderRight: " 1px solid black" }]}>Gst %</Text>
                            <Text style={[styles.headerCell, { textAlign: 'center', width: '13%', }]}>Amount</Text>
                        </View>
                        {/* Add table content here */}
                        {itemsForPage.map((item, index) => {

                            const serialNumbers = item.locations.map(location => location.serialNumber).join(' / ');
                            let qty = item?.issue_qty && !isNaN(item.issue_qty) 
                            ? Number(item.issue_qty).toFixed(2) 
                            : item?.recv_qty ?? "N/A";
                          

                            return (<View key={index} style={[styles.row, index % 2 === 0 ? { color: 'black', } : { color: 'blue' }]}>
                                <Text style={{
                                    textAlign: 'left',
                                    fontSize: 10,
                                    width: "5%",
                                    paddingLeft: 10, paddingRight: 10,
                                    borderRight: " 1px solid black",
                                    paddingHorizontal: 5, paddingVertical: 5
                                }}>{startIndex + index + 1}</Text>
                                <View style={{
                                    width: "25%",
                                    textAlign: "left",
                                    borderRightWidth: 1,
                                    borderRightColor: 'black',
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    paddingHorizontal: 5,
                                    paddingVertical: 5,
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                    fontSize: 8
                                }}>
                                    <Text style={{ marginBottom: 5 }}>
                                        {item.item_name.charAt(0)?.toUpperCase() + item.item_name.slice(1)?.toLowerCase()}
                                    </Text>
                                    {/* {item.locations.map((location, index) => ( */}
                                    {/* {serialNumbers.length != 0 && <Text key={index} style={{ marginTop: 5 }}>
                                        S.No: {serialNumbers}
                                    </Text>} */}
                                    {/* ))} */}

                                    {item.locations.length != 0 && item.locations.map((location, index) => (
                                        <Text style={{ marginTop: 2, marginLeft: -3 }}> S.No: {location.serialNumber}</Text>
                                    ))}
                                </View>
                                <Text style={[styles.cell, { width: "10%", textAlign: "left", borderRight: " 1px solid black", paddingLeft: 10, paddingRight: 10, paddingHorizontal: 5, paddingVertical: 5 }]}>{item?.item_hsn_code_one_pc}</Text>
                                <Text style={[styles.cell, { width: "10%", textAlign: "right", borderRight: "1px solid black", paddingLeft: 10, paddingRight: 10, paddingHorizontal: 5, paddingVertical: 5 }]}>
                                    {qty}
                                </Text>

                                <Text style={[styles.cell, { width: "10%", textAlign: "center", borderRight: " 1px solid black", paddingLeft: 10, paddingRight: 10, paddingHorizontal: 5, paddingVertical: 5 }]}>{item?.item_packing_type_one_pc}</Text>
                                <Text style={[styles.cell, { width: "11%", textAlign: "right", borderRight: " 1px solid black", paddingLeft: 10, paddingRight: 10, paddingHorizontal: 5, paddingVertical: 5 }]}>{item?.rent_rate?.toFixed(2)}</Text>
                                <Text style={[styles.cell, { width: "13%", textAlign: "right", borderRight: " 1px solid black", paddingLeft: 10, paddingRight: 10, paddingHorizontal: 5, paddingVertical: 5 }]}>{item?.item_gross_amount_one_pc?.toFixed(2)}</Text>

                                <Text style={[styles.cell, { width: "8%", textAlign: "right", borderRight: " 1px solid black", paddingLeft: 10, paddingRight: 10, paddingHorizontal: 5, paddingVertical: 5 }]}>{item?.item_gst_percenatge_one_pc?.toFixed(2)}</Text>
                                <Text style={[styles.cell, { width: "13%", textAlign: "right", paddingLeft: 10, paddingRight: 10, paddingHorizontal: 5, paddingVertical: 5 }]}>{item?.total_amount_with_gst_one_pc?.toFixed(2)}</Text>

                            </View>)
                        })}
                    </View>

                    {isLastPage && (<View style={{ display: "flex", width: '97.7%', height: "45%", minHeight: 225, border: "1px solid black", borderBottomLeftRadius: 10, borderBottomRightRadius: 10, marginLeft: 0, marginTop: 0 }}>

                        <View style={{ flexDirection: "row", height: "70%", }}>

                            <View style={{ width: "65%", borderRightWidth: 1, borderBottom: 1 }}>
                                <Text>hhhh</Text>
                            </View>

                            <View style={{ display: "flex", flexDirection: "column", width: "35%", borderBottomWidth: 1, fontSize: 9 }}>

                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '60%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>Bill Value</Text>
                                    </View>
                                    <Text>:</Text>
                                    <View style={{ width: '40%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>{printData?.challanMasterData?.gross_amt?.toFixed(2)}</Text>
                                    </View>
                                </View>


                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '60%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>Freight/Cartage</Text>
                                    </View>
                                    <Text>:</Text>
                                    <View style={{ width: '40%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>{printData?.challanMasterData?.cart_amt_final?.toFixed(2)}</Text>
                                    </View>
                                </View>

                                {/* <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                  <View style={{ width: '50%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                    <Text style={{ fontSize: 9 }}>GST%</Text>
                  </View>
                  <View style={{ width: '50%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                    <Text style={{ fontSize: 9 }}>{(printData.challanMasterData.tax_code.toFixed(2))}</Text>
                  </View>
                </View> */}



                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '60%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>SGST Amount ( % {printData?.challanMasterData?.tax_code} )</Text>
                                    </View>
                                    <Text>:</Text>
                                    <View style={{ width: '40%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>
                                            {/* {(printData?.challanMasterData?.addr_gst_type === "SGST-CGST" && printData?.challanMasterData?.tax_amt / 2).toFixed(2)} */}
                                            {printData && printData.challanMasterData && printData.challanMasterData.addr_gst_type === "SGST-CGST" && printData.challanMasterData.tax_amt
                                                ? (printData.challanMasterData.tax_amt / 2)?.toFixed(2)
                                                : ""}
                                        </Text>
                                    </View>
                                </View>

                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '60%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>CGST Amount ( % {printData?.challanMasterData?.tax_code} )</Text>
                                    </View>
                                    <Text>:</Text>
                                    <View style={{ width: '40%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>
                                            {/* {(printData?.challanMasterData?.addr_gst_type === "SGST-CGST" && printData?.challanMasterData?.tax_amt / 2)?.toFixed(2)} */}
                                            {printData && printData.challanMasterData && printData.challanMasterData.addr_gst_type === "SGST-CGST" && printData.challanMasterData.tax_amt
                                                ? (printData.challanMasterData.tax_amt / 2)?.toFixed(2)
                                                : ""}
                                        </Text>
                                    </View>
                                </View>


                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '60%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>IGST Amount ( % {(printData?.challanMasterData.tax_code)} )</Text>
                                    </View>
                                    <Text>:</Text>
                                    <View style={{ width: '40%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>
                                            {/* {(printData?.challanMasterData.addr_gst_type != "SGST-CGST" ? (printData?.challanMasterData.tax_amt)?.toFixed(2) : 0)} */}
                                            {printData && printData.challanMasterData && printData.challanMasterData.tax_amt !== undefined
                                                ? (printData.challanMasterData.addr_gst_type !== "SGST-CGST"
                                                    ? printData.challanMasterData.tax_amt?.toFixed(2)
                                                    : (0)?.toFixed(2))
                                                : ""}
                                        </Text>
                                    </View>
                                </View>

                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '60%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>Round  off</Text>
                                    </View>
                                    <Text>:</Text>
                                    <View style={{ width: '40%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>{printData?.challanMasterData?.roundoff_amount?.toFixed(2)}</Text>
                                    </View>
                                </View>


                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '60%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>Grand Total</Text>
                                    </View>
                                    <Text>:</Text>
                                    <View style={{ width: '40%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "right", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text style={{ fontSize: 9 }}>{printData?.challanMasterData?.final_amount?.toFixed(2)}</Text>
                                    </View>
                                </View>

                                <View style={{ flexDirection: 'row', display: "flex", alignItems: 'center' }}>
                                    <View style={{ width: '100%', paddingHorizontal: 5, paddingVertical: 5, textAlign: "left", paddingRight: 10, paddingLeft: 10 }}>
                                        <Text>Amount In Words : {result}</Text>
                                    </View>
                                </View>

                            </View>
                        </View>
                        <View style={{ flexDirection: "row", height: "30%", width: "100%", display: "flex", }}>
                            <View style={{ fontSize: 8, width: "35%", padding: 5, borderRightWidth: 1 }}>
                                <Text>Terms and condition tabke  to be  inserted ina system records </Text>
                                <Text>1. All disputes are subject to DELHI Jurisdiction.</Text>
                                <Text>1. All disputes are subject to DELHI Jurisdiction.</Text>
                                <Text>1. All disputes are subject to DELHI Jurisdiction.</Text>
                                <Text>E. & O.E.</Text>
                                <Text style={{ marginTop: 10 }}>Billing Software By : Shivkms,.1000,Deva Ram Park,Tri Nagar,Delhi-35</Text>
                            </View>

                            <View style={{ fontSize: 8, width: "30%", borderRightWidth: 1 }}>
                                <View style={{ borderBottomWidth: 1 }}>
                                    <Text style={{ alignSelf: "center" }}> Bank Details</Text>
                                </View>
                                <Text style={{ marginTop: 5, marginLeft: 5 }} >Bank Account Number:  123456790123456</Text>
                                <Text style={{ marginTop: 5, marginLeft: 5 }}>Bank Branch: Tri Nagar</Text>
                                <Text style={{ marginTop: 5, marginLeft: 5 }}>IFSC:BARBOTRINAG</Text>
                                <Text style={{ marginTop: 5, marginLeft: 5 }}>Bank Name : BANK OF Baroda</Text>
                            </View>
                            <View style={{ fontSize: 9, width: "35%", textAlign: "right", padding: 5, paddingRight: 5, display: "flex" }}>
                                <Text>For {printData.System_Records_data.school_name}</Text>
                                <Text style={{ marginTop: 40 }}>Authorised Signatory  </Text>

                            </View>
                        </View>
                    </View>)}

                </View>
            );
        }

        return pageViews;
    };


    const [finalYear, setFinalYear] = useState("")
    const calculateYearFin = (date) => {
        const selectedDate = new Date(date);
        const selectedMonth = selectedDate.getMonth();

        let startYear, endYear;
        if (selectedMonth < 3) {
            startYear = selectedDate.getFullYear() - 1;
            endYear = selectedDate.getFullYear();
        } else {
            startYear = selectedDate.getFullYear();
            endYear = selectedDate.getFullYear() + 1;
        }

        setFinalYear(`${startYear}-${endYear}`);
    }

    useEffect(() => {
        if (printData.challanMasterData.bill_date) {
            calculateYearFin(printData.challanMasterData.bill_date)
        }
    }, [])

    const MyDocument = (
        <Document>
            <Page size="A4" style={styles.page}>

                {/* <View style={{ flexDirection: "row", marginTop: 22, display: "flex", }}>
                <Text style={{ fontSize: 10, alignSelf: "flex-start" }}>GSTIN: {printData?.challanMasterData?.gstno}</Text>
                <Text style={{ fontSize: 12, marginLeft: 130 }}>Tax Invoice </Text>, 
                </View> */}

                <View style={{
                    display: "flex", flexDirection: "row", width: "100%",
                    borderRadius: 5, alignSelf: "center", marginTop: 10,
                    alignItems: 'center' // Vertically center the text
                }}>
                    <View style={{ flexDirection: "row", justifyContent: 'flex-start', flex: 1, marginLeft: 40 }}>
                        <Text style={{ fontSize: 7, textAlign: 'center' }}> GSTIN : </Text>
                        <Text style={{ fontSize: 7, textAlign: 'center' }}>{printData?.challanMasterData?.gstno}</Text>
                    </View>

                    <Text style={{ fontSize: 10, textAlign: 'center', textDecoration: 'underline', flex: 1, justifyContent: "center", alignSelf: "center", }}> TAX INVOICE </Text>

                    <View style={{ flex: 1 }} />
                </View>


                {/*  show company log and compny detail    */}

                <View style={{ display: "flex", flexDirection: 'row', marginTop: 15, height: 100, width: "100%", }}>
                    {/* Company Icon
                    <Image
                        style={{ width: 50, height: 50 }}
                        size="large"
                        source={require('./company_icon.png')} // Ensure correct relative path
                    /> */}

                    <View style={{ flexDirection: "column", justifyContent: "flex-start", flex: 1.3, }}>
                        <Image
                            style={{ width: 40, height: 40, marginTop: -25 }}
                            size="large"
                            source={"/assets/logos/" + printData?.System_Records_data?.school_logo} // Ensure correct relative path
                        />
                        <Text style={{ color: "red", fontSize: 20, marginRight: 10, marginBottom: 5 }}>
                            {printData?.System_Records_data?.school_name}
                            {/* Carbon India */}
                        </Text>
                        <Text style={{ fontSize: 8, marginRight: 10, marginBottom: 2, }}>
                            Sales Office: A/73-77, Arya Nagar, Industrial Area
                            Loni - 201102, Distt., Ghaziabad (U.P.)
                            {/* {printData?.System_Records_data?.school_name + printData?.System_Records_data?.home_state} */}
                        </Text>

                        <Text style={{ fontSize: 8, marginRight: 10, marginBottom: 2 }}>
                            Phones: 011-23235503,23236666,9313536464,
                            9310336464
                            {/* {printData?.System_Records_data?.company_phone} */}
                        </Text>
                        <Text style={{ fontSize: 8, marginRight: 10, marginBottom: 2, }}>
                            E-mail: {printData?.System_Records_data?.email_sender}
                        </Text>

                    </View>

                    <View style={{ flexDirection: "column", justifyContent: "cener", flex: 1, }}>

                        <Text style={{ fontSize: 10 }}>
                            M/s. {printData.challanMasterData.pname}
                        </Text>
                        <View style={{ justifyContent: 'flex-start' }}>
                            <Text style={{ fontSize: 8, marginLeft: 16 }}>
                                {printData.challanMasterData.addr_type} {printData.challanMasterData.add1} {printData.challanMasterData.add2}
                                {printData.challanMasterData.add3_location} {printData.challanMasterData.add5_state} {printData.challanMasterData.add4_city}
                                {printData.challanMasterData.add6_pincode}
                                PLOT NO. D- 52 A, PHASE - IV, IDA
                                JEEDIMETLA, HYDERABAD - 500 055,
                                Telangana
                            </Text>
                        </View>
                        <View style={{ position: 'absolute', bottom: 9, left: 2, right: 2, flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Text style={{ fontSize: 8, marginTop: -16 }}>
                                GSTIN. {printData.challanMasterData.gstno}
                            </Text>
                            <Text style={{ fontSize: 8, marginTop: -16 }}>
                                State Code. {printData.challanMasterData.state_code}
                            </Text>
                        </View>
                    </View>


                    <View style={{ flexDirection: "column", justifyContent: "cener", flex: .7, marginTop: 60 }}>
                        <View style={{ flexDirection: "row", marginLeft: 20 }}>
                            <Text style={{ fontSize: 8 }}>
                                Inv.Date :
                            </Text>
                            <Text style={{ fontSize: 8, marginLeft: 20 }}>
                                {printData.challanMasterData.bill_date?.split('T')[0]}
                            </Text>
                        </View>

                    </View>



                    {/* <View style={{ flexDirection: "column", justifyContent: "flex-end", flex: .6, }}>
                        <View style={{ flexDirection : "row" }}>
                            <Text style={{ fontSize : 9}}>Invoice date : 12/12/2023</Text>

                        </View>
                        
                    </View> */}
                </View>


                {/*  show the  buyer addres and shiiping address  */}
                {/* <View style={{ display: "flex", flexDirection: "row", width: "100%", height: 140, border: "1px solid black", borderRadius: 5, marginTop: 1 }}>
                    <View style={{ flexDirection: "column", width: "50%", }}>
                        <View style={{ flexDirection: "column", padding: 2, height: "50%", borderRightWidth: 1, }}>

                            <Text style={{ fontSize: 8, textAlign: 'center', paddingBottom: 10, textDecoration: 'underline' }}>
                                Buyer / Detail of Receiver ( Billed To )
                            </Text>
                            <Text style={{ fontSize: 8 }}>
                                M/s. {printData.challanMasterData.pname}
                            </Text>
                            <View style={{ justifyContent: 'flex-start' }}>
                                <Text style={{ fontSize: 8, marginLeft: 16 }}>
                                    {printData.challanMasterData.addr_type} {printData.challanMasterData.add1} {printData.challanMasterData.add2}
                                    {printData.challanMasterData.add3_location} {printData.challanMasterData.add5_state} {printData.challanMasterData.add4_city}
                                    {printData.challanMasterData.add6_pincode}
                                </Text>
                            </View>
                            <View style={{ position: 'absolute', bottom: 9, left: 2, right: 2, flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ fontSize: 8 }}>
                                    GSTIN. {printData.challanMasterData.gstno}
                                </Text>
                                <Text style={{ fontSize: 8 }}>
                                    State Code. {printData.challanMasterData.state_code}
                                </Text>
                            </View>

                        </View>
                        <View style={{ flexDirection: "column", padding: 5, height: "50%", borderRightWidth: 1, borderTopWidth: 1 }}>
                            <Text style={{ fontSize: 8, textAlign: 'center', paddingBottom: 10, textDecoration: 'underline' }}>
                                Consignee ( Shipped To )
                            </Text>
                            <Text style={{ fontSize: 8 }}>
                                M/s. {printData.challanMasterData.pname}
                            </Text>
                            <View style={{ justifyContent: 'flex-start' }}>
                                <Text style={{ fontSize: 8, marginLeft: 16 }}>

                                </Text>
                            </View>
                            <View style={{ position: 'absolute', bottom: 9, left: 2, right: 2, flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ fontSize: 8 }}>
                                    GSTIN.
                                </Text>
                                <Text style={{ fontSize: 8 }}>
                                    State Code.
                                </Text>
                            </View>
                        </View>
                    </View>

                    <View style={{ flexDirection: 'column', width: '50%' }}>
                        <View style={{ flexDirection: 'column', height: '60%', borderColor: 'black', borderBottomWidth: 1 }}>
                            <View style={{ flexDirection: 'row', borderBottomWidth: 1 }}>
                                <View style={{ flexDirection: "row" }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>Quation No.</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6, borderRightWidth: 1 }}>{finalYear + " / " + printData.challanMasterData.billno_automatic}</Text>
                                </View>
                                <View style={{ flexDirection: "row" }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>Date:</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6 }}>{printData.challanMasterData.bill_date?.split('T')[0]}</Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', borderBottomWidth: 1 }}>
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>P.O. No. :</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6, borderRightWidth: 1 }}>{printData.challanMasterData.cart_po_date}</Text>
                                </View>
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>P.O. Date :</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6 }}>{printData.challanMasterData.cart_po_date}</Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <View style={{ flexDirection: "row" }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>Transporter:</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '190%', borderColor: 'black', padding: 6, borderRightWidth: 1 }}>7510 6302 1036</Text>

                                </View>
                                <View style={{ flexDirection: "row" }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>Freight :</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6 }}>{printData.challanMasterData.gr_no}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={{ flexDirection: 'column', height: '40%', borderColor: 'black' }}>
                            <View style={{ flexDirection: 'row', borderBottomWidth: 1 }}>
                                <View style={{ flexDirection: "row" }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>Vehicle No.</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6 }}>{printData.challanMasterData.vehicleno}</Text>
                                </View>
                                <View style={{ flexDirection: "row" }}>
                                    <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>G.R. No</Text>
                                    <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6 }}>{printData.challanMasterData.contact_prs_ph_no}</Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', }}>
                                <Text style={{ fontSize: 8, width: '40%', height: '100%', borderColor: 'black', padding: 6 }}>Terms of Delivery</Text>
                                <Text style={{ fontSize: 8, width: '60%', height: '100%', borderColor: 'black', padding: 6 }}>outputs the parsed data to the console outputs the parsed data to the console</Text>

                            </View>
                            <Text style={{ fontSize: 8, paddingLeft: 5 }}>{printData.challanMasterData.transport}</Text>
                        </View>
                    </View>
                </View> */}




                {/*show item list  */}
                <View style={{ fontSize: 10, alignSelf: "flex-start", marginTop: -15 }}>
                    return <>{renderPages()}</>;
                </View>



            </Page>
        </Document>
    );

    return (
        <div>
            <PDFViewer width="100%" height={500}>
                {MyDocument}
            </PDFViewer>

            <PDFDownloadLink document={MyDocument} fileName="invoice.pdf">
                {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
            </PDFDownloadLink>

            <PDFDownloadLink document={MyDocument} onClick={printData.onHandleBackInvoice} style={{ marginLeft: 10 }}>
                Back
            </PDFDownloadLink>

            {/* <button className="btn btn-secondary" onClick={printData.onHandleBackInvoice}>
        Back
      </button> */}
        </div>
    );
};

export default CreatePdf_Formate5;
